import styled from 'styled-components';
import { rem } from 'polished';

const StyledSubTit = styled.p`
  font-size: ${rem('14px')};
  line-height: ${rem('22px')};
  padding-top: ${rem('20px')};
`;

export { StyledSubTit };
